// extracted by mini-css-extract-plugin
module.exports = {"bottom-column-wapper":"gz","bottomColumnWapper":"gz","bottom-column-panel":"gA","bottomColumnPanel":"gA"};